import { createAsyncThunk } from '@reduxjs/toolkit';
import {
	getUtmZoneListApi as getUtmZoneListApiHelper,
	getUtmZoneListQueryApi as getUtmZoneListQueryApiHelper,
	getUtmZoneApi,
	addNewUtmZoneApi,
	updateUtmZoneApi,
	deleteUtmZoneApi,
	checkUtmZoneExistsApi,
} from '../../helpers/utm_zone/api_helper';
import { toast } from 'react-toastify';

export const getUtmZoneList = createAsyncThunk('utmZone/getUtmZoneList', async () => {
	try {
		const response = await getUtmZoneListApiHelper();
		return response.data || response;
	} catch (error) {
		return error;
	}
});

export const getUtmZoneListQuery = createAsyncThunk('utmZone/getUtmZoneListQuery', async (params) => {
	try {
		const response = await getUtmZoneListQueryApiHelper(params);
		return response;
	} catch (error) {
		return error;
	}
});

export const getUtmZone = createAsyncThunk('utmZone/getUtmZone', async (id) => {
	try {
		const response = await getUtmZoneApi(id);
		return response.data || response;
	} catch (error) {
		return error;
	}
});

export const addNewUtmZone = createAsyncThunk('utmZone/addNewUtmZone', async (utmZone) => {
	try {
		const response = await addNewUtmZoneApi(utmZone);
		toast.success('UTM agregado exitosamente', { autoClose: 3000 });
		return response.data || response;
	} catch (error) {
		toast.error('Error al agregar el UTM', { autoClose: 3000 });
		return error;
	}
});

export const updateUtmZone = createAsyncThunk('utmZone/updateUtmZone', async (utmZone) => {
	try {
		const response = await updateUtmZoneApi(utmZone);
		toast.success('Huso UTM actualizado exitosamente', { autoClose: 3000 });
		return response.data || response;
	} catch (error) {
		toast.error('Error al actualizar el huso UTM', { autoClose: 3000 });
		return error;
	}
});

export const deleteUtmZone = createAsyncThunk('utmZone/deleteUtmZone', async (utmZone) => {
	try {
		const response = await deleteUtmZoneApi(utmZone);
		toast.success('Huso UTM eliminado exitosamente', { autoClose: 3000 });
		return response.data || response;
	} catch (error) {
		toast.error('Error al eliminar el huso UTM', { autoClose: 3000 });
		return error;
	}
});

export const checkUtmZoneExists = createAsyncThunk('utmZone/checkUtmZoneExists', async (name) => {
	try {
		const response = await checkUtmZoneExistsApi(name);
		return response.data || response;
	} catch (error) {
		return error;
	}
});
